export const TOKENLESS_URLS = ['/api/user-manual/all','/api/user-manual/search']